import React from 'react';
import './index.css';
import { IonIcon } from '@ionic/react';
import { chevronForward } from 'ionicons/icons';
import { getConfig } from '../../appConfig';

const DashboardBar = ({ onDismiss, handleClick, children,className }) => (
	<div className={`${className?className:''} dashboard-bar-wrapper ${getConfig().flags.hideNotificationBannerIcons?'dashboard-bar-wrapper-only-text':''}`}>
		<div className="dashboard-scrim" onClick={onDismiss ? onDismiss : null}></div>
		<div className="dashboard-bar  box-wrapper" onClick={handleClick}>
			{children}
			<IonIcon icon={chevronForward}  />

		</div>
	</div>
);

export default DashboardBar;
